var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"npl-dialog"},[_c('div',{staticClass:"npl-dialog-title"},[_c('img',{staticStyle:{"width":"30px"},attrs:{"src":"/3DModel/npl/wechat.png"}}),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"npl-dialog-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }